const scrollToTop = () => {
    const opts = { top: 0, behavior: 'smooth' };
    setTimeout(() => {
        const root = document.getElementById('root');
        if (root)
            root.scrollTo(opts);
        const main = document.querySelector('.main-content');
        if (main)
            main.scrollTo(opts);
        window.scrollTo(opts);
    }, 50);
};
export { scrollToTop };
